import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_steps = _resolveComponent("steps")!
  const _component_antragsteller = _resolveComponent("antragsteller")!
  const _component_vertragsunterlagen_digital = _resolveComponent("vertragsunterlagen-digital")!
  const _component_zahlungsdaten = _resolveComponent("zahlungsdaten")!
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_info_box = _resolveComponent("info-box")!
  const _component_datei_upload = _resolveComponent("datei-upload")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_hug_mitgliedschaft = _resolveComponent("hug-mitgliedschaft")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_steps, {
      active: 3,
      items: _ctx.navItems,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createElementVNode("section", null, [
      _createVNode(_component_antragsteller, {
        fehler: _ctx.fehler,
        ref: "antragstellerRef",
        onGeburtsdatumGeaendert: _ctx.onGeburtsdatumGeaendert
      }, null, 8, ["fehler", "onGeburtsdatumGeaendert"]),
      _createVNode(_component_vertragsunterlagen_digital, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      _createVNode(_component_zahlungsdaten, {
        fehler: _ctx.fehler,
        ref: "zahlungsdatenRef"
      }, null, 8, ["fehler"]),
      (_ctx.isMakler && _ctx.enthaeltVGV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_ueberschrift, {
            key: 0,
            "zeige-info": true,
            "info-box-id": "dateienInfo",
            titel: "Dateien hochladen"
          }))
        : _createCommentVNode("", true),
      (_ctx.isMakler && _ctx.enthaeltVGV(_ctx.piniaStore.state))
        ? (_openBlock(), _createBlock(_component_zeile, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _createVNode(_component_info_box, { id: "dateienInfo" }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode(" Sie können bis zu 10 Dokumente mit jeweils 10 MB hochladen. "),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" Zulässige Dateiformate: .jpeg, .jpg, .png, .pdf und .tiff. ")
                    ])),
                    _: 1,
                    __: [3]
                  }),
                  _createVNode(_component_datei_upload, { id: "dateien" })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.zeigeFrageHugNachlass)
        ? (_openBlock(), _createBlock(_component_hug_mitgliedschaft, {
            key: 2,
            fehler: _ctx.fehler
          }, null, 8, ["fehler"]))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_zelle, {
            offset: 4,
            breite: 6
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "c-button c-button--full-width u-mar-t-2 u-mar-b-2 mobil-mehrAbstand",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nextPage())),
                "data-cy": "submitIhreDaten"
              }, " Weiter ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.istSichtbar('modalBeitragsaenderung'))
      ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 0 }, _ctx.modalBeitragsaenderung, {
          onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.wechsleSichtbarkeit('modalBeitragsaenderung')))
        }), null, 16))
      : _createCommentVNode("", true)
  ], 64))
}